import { NgModule } from '@angular/core';
import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { environment } from 'src/environments/environment';

export const routes: Routes = [
  // If you need more routes, please consider creating new modules containing them.
  { path: '', redirectTo: environment.redirectRoute, pathMatch: 'full' }, 
  { path: '**', redirectTo: '/404' } // NotFoundComponent
];

const routerOptions: ExtraOptions = {
  scrollPositionRestoration: 'enabled', // <-- ENABLED
  //anchorScrolling: 'enabled', // (Optional) Scrolls to anchors
  //scrollOffset: [0, 64], // [x, y] offset when scrolling to an element (optional)
  onSameUrlNavigation: 'reload'
};


@NgModule({
  //imports: [RouterModule.forRoot(routes, {scrollPositionRestoration: 'enabled', onSameUrlNavigation: 'reload'})],
  imports: [RouterModule.forRoot(routes, routerOptions)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
